var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"hide-side-bar":_vm.hideSideBar,"hide-top-nav":_vm.hideTopNav}},[(_vm.sessionLoading)?_c('div',{staticClass:"loader"},[_c('b-spinner',{attrs:{"label":"Spinning"}})],1):[_c('div',{class:{
        'main-container--shrinked': _vm.sidebarActive,
        'main-container': !_vm.sidebarActive,
        'no-sidebar': _vm.hideSideBar,
      }},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }